import misc from "./Misc";
import registration from "./Registration";
import sidenav from "./Sidenav";
import overview from "./Overview";
import pos from "./POS";
import settings from "./Settings";
import transaction from "./Transaction";
import settlements from "./Settlements";
import promo from "./Promo";
import redemption from "./Redemption";
import credit from "./Credit";
import customers from './Customers.js'
import billing from './Billing'
import payout from './Payout'
import rewardAds from './RewardAds'
import reports from './Reports'

const english = {
  translation: {
    sidenav,
    registration,
    overview,
    misc,
    pos,
    settings,
    transaction,
    settlements,
    promo,
    redemption,
    credit,
    customers,
    billing,
    payout,
    rewardAds,
    reports
  }
}

export default english;